// extracted by mini-css-extract-plugin
export default {"countertopOtionsMenu":"style_countertopOtionsMenu__ugO0x"};